<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Transferencias</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            <b-col sm="2">
              <b-form-group
                :label="crearLabel('Ejecutivos', 'codejecutivo', 'datosFormulario')"
                label-for="codejecutivo"
              >
                <b-form-select
                  :options="valEjecutivos"
                  v-model="datosFormulario.codejecutivo"
                  :disabled="campoBloqueado('codejecutivo', 'datosFormulario')"
                ></b-form-select>

                <span class="error-validacion-campo">{{ mensajeValidacionCampo.codejecutivo }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group
                :label="crearLabel('Fecha de pago en adelante', 'fecpago', 'datosFormulario')"
                label-for="fecpago"
                :horizontal="false"
              >
                <b-input-group>
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-calendar"></i>
                    </span>
                  </div>
                  <datepicker
                    :language="es"
                    format="dd/MM/yyyy"
                    :use-utc="true"
                    input-class="form-control"
                    v-model="datosFormulario.fecpago"
                    :disabled="campoBloqueado('fecpago', 'datosFormulario')"
                  ></datepicker>
                  <span class="error-validacion-campo">{{ mensajeValidacionCampo.fecpago }}</span>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group
                :label="crearLabel('Solo Retenidas por deuda de Prima', 'retdeuda', 'datosFormulario')"
                label-for="retdeuda"
              >
                <b-form-select
                  :options="valRetenidas"
                  v-model="datosFormulario.retdeuda"
                  :disabled="campoBloqueado('retdeuda', 'datosFormulario')"
                ></b-form-select>

                <span class="error-validacion-campo">{{ mensajeValidacionCampo.retdeuda }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group
                :label="crearLabel('Solo Transferencias', 'transoli', 'datosFormulario')"
                label-for="transoli"
              >
                <b-form-select
                  :options="valTransferencias"
                  v-model="datosFormulario.transoli"
                  :disabled="campoBloqueado('transoli', 'datosFormulario')"
                ></b-form-select>

                <span class="error-validacion-campo">{{ mensajeValidacionCampo.transoli }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group
                :label="crearLabel('Solo Proceso Manual', 'prcmanual', 'datosFormulario')"
                label-for="prcmanual"
              >
                <b-form-select
                  :options="valProceso"
                  v-model="datosFormulario.prcmanual"
                  :disabled="campoBloqueado('prcmanual', 'datosFormulario')"
                ></b-form-select>

                <span class="error-validacion-campo">{{ mensajeValidacionCampo.prcmanual }}</span>
              </b-form-group>
            </b-col>

            <b-col lg="2"> 
              <b-form-group
                label="asdf"
                label-class="label-blanco"
              >
              <b-form-checkbox
                v-model="datosFormulario.ckfiniqsinsol"
                value="s"
                unchecked-value="n"
                @change="asgckfiniqsinsol"
                v-b-tooltip.hover title="Con finiquito vinculado y sin solicitud"
                >
                Finiquitos sin solicitud
              </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          

          <div slot="footer">
            <div class="form-actions">
              <el-row>
                <el-col>
                  <b-button variant="primary" @click="buscar">
                    <i class="fa fa-search"></i> Consultar
                  </b-button>
                  <b-button variant="primary" @click="pre_insertar">
                    <i class="fa fa-eraser"></i> Limpiar
                  </b-button>
                  <b-button variant="primary" @click="descargarExcel">
                    <i class="fa fa-file-excel-o"></i> Exportar
                  </b-button>
                  
                  <b-button variant="success" @click="valmarcados('A')" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-save"></i> Solicitar Transferencia
                  </b-button>
                  <b-button variant="warning" @click="valmarcados('B')" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-save"></i> Proceso Manual
                  </b-button>
                  <b-button variant="danger" @click="valmarcados('C')" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-save"></i> Quitar Marca
                  </b-button>
                  <b-button class="bt_fecransferencia" variant="success" @click="valmarcados('D')" style="color: #ffffff; margin-left: 10px;">
                    <i class="fa fa-edit"></i> Fecha Transferencia
                  </b-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Transferencias</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @selection-change="handleSelectionChange"
                  width="100%"
                  >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    sortable="custom"
                    class="table-responsive"
                    :formatter="formatter"
                  >
                  
                  <template slot-scope="scope">
                    <div v-if="title.prop == 'POLIZA'">  
                        <el-button type="text" @click="recuperar_mailDeudaPrima(scope.row.POLIZA, scope.row.SNFBENEFICIARIO, scope.row.RETDEUDA, scope.row.TRANSOLI, scope.row.PRCMANUAL, scope.row.FECPAGO )">{{scope.row.POLIZA}}</el-button>
                    </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
                  </template>

                  </el-table-column>
                  <el-table-column label="Observación" min-width="250px" align="left">
                    <template slot-scope="scope">
                      <el-tooltip
                          v-for="button in customButtonsForRowObs(scope.row)"
                          :key="button.id"
                          :content="button.tooltip"
                          placement="top">
                          <el-button
                            type="text"
                            @click="button.handler"
                          >
                            <i v-bind:class="button.icon"></i>
                            {{ button.name }}
                          </el-button>
                      </el-tooltip>
                      {{ scope.row.OBSERVACION }}
                    </template>
                  </el-table-column>

                  <el-table-column label="Finiquito" min-width="100px" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="finiquitos(scope.row.POLIZA,scope.row)">Ver</el-button>   
                      
                    </template>
                  </el-table-column>

                  <el-table-column label="Documentación" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-tooltip
                        v-for="button in customButtonsForRow(scope.row)"
                        :key="button.id"
                        :content="button.tooltip"
                        placement="top">
                        <el-button
                          type="text"
                          @click="button.handler"
                        >
                          <i v-bind:class="button.icon"></i>
                          {{ button.name }}
                        </el-button>
                    </el-tooltip>
                  </template>
                  </el-table-column>


                  <el-table-column type="selection" width="35" reserve-selection><!-- reserve-selection -->
                  </el-table-column>

                  <el-table-column label="Gen. Finiquito" min-width="160px" align="center">
                    <template slot-scope="scope">
                      <el-button  type="text" @click="imprime_finiquitos(scope.row.POLIZA, scope.row.SNFBENEFICIARIO, scope.row.FECPAGO)"> <i class="fa fa-print"> </i> Gen. Finiquito
                      </el-button>   
                      
                    </template>
                  </el-table-column>

                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      </b-col>
    </b-row>

    <!-- Trasferencia-->
    <b-modal
      title="Trasferencia"
      cancel-title="Cancelar"
      ok-title="Continuar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalTransferencia"
      @ok="trasferencia"
      @cancel="modalTransferencia = false"
    >
      Se marcarán para transferencia todas las pólizas seleccionadas, ¿desea continuar?
    </b-modal>

    <!-- Proceso manual-->
    <b-modal
      title="Proceso Manual"
      cancel-title="Cancelar"
      ok-title="Continuar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalManual"
      @ok="manual"
      @cancel="modalManual = false"
    >
      Se marcarán para proceso manual todas las pólizas seleccionadas, ¿desea continuar?
    </b-modal>

    <!-- Quitar Marca-->
    <b-modal
      title="Quitar Marca"
      cancel-title="Cancelar"
      ok-title="Continuar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalQuitar"
      @ok="quitar"
      @cancel="modalQuitar = false"
    >
      Se quitará la marca de proceso manual o transferencia para todas las pólizas seleccionadas, ¿desea continuar?
    </b-modal>

    <b-modal
      title="Registrar Fecha de Transferencia"
      cancel-title="Cancelar"
      ok-title="Continuar"
      class="modal-success"
      v-model="modalModificar"
      @ok="fechatransferencia();"
      @cancel="modalModificar = false"
    >
      <b-input-group>
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="fa fa-calendar"></i>
            </span>
          </div>
          <datepicker
            :language="es"
            format="dd/MM/yyyy"
            :use-utc="true"
            input-class="form-control"
            v-model="datosFormulario.hoy"
            :disabled="campoBloqueado('hoy', 'datosFormulario')"
          ></datepicker>
          <span class="error-validacion-campo">{{ mensajeValidacionCampo.hoy }}</span>
        </b-input-group>
        <br>
        Se registrará la "Fecha de Transferencia" de los registros marcados con la fecha de seleccionada.  
      </b-modal>

    <!-- Detalle finiquitos -->
    <b-modal
      size="lg"
      title="Finiquitos"
      cancel-title="Cerrar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalFiniquitos"
      @ok="guardarLinkContishare();"
      @cancel="modalFiniquitos = false"
    >
      <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable3"
                  :data="dataFiniquitos"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @select="handleSelectionChange2"
                  @select-all="selectAll"    
                                
                >
                  <el-table-column
                    v-for="title in titlesFiniquitos"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                  
                  <el-table-column label="" min-width="100px" align="center">
                  <template slot-scope="scope">
                      <el-button type="text" @click="verFiniquito(scope.row.LINK)">Ver</el-button>   
                  </template>
                  </el-table-column>

                  <el-table-column type="selection" width="35" reserve-selection>
                  </el-table-column>

                  <el-table-column label="" min-width="10px" align="center">
                  </el-table-column>

                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-modal>

    <b-modal
      title="Observación"
      cancel-title="Cancelar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalObservacion"
      @ok="guardarObservacion();"
      @cancel="modalObservacion = false"
    >
      <b-form-textarea
        id="obs"
        v-model="modalDataObservacion.OBSERVACION"
        placeholder="Ingrese la observación"
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-modal>


    <!-- Detalle finiquitos -->
    <b-modal
      size="xl"
      :title="this.datosFormulario.title"
      cancel-title="Cerrar"
      ok-title="Generar correo"
      v-model="modalEmail"
      @ok="mail_DeudaPrima();"
      @cancel="modalEmail = false"
    >
    
      <b-row>
        <b-col lg="12">
          <!-- <p><b>Asunto: </b>Indemnización retenida por deuda de prima - póliza N° 208104227 / MULTIACEROS S.A. / MULTIACEROS S.A.</p> -->
          <br>
          <p>Estimado asegurado,</p>
          <br>
          <p>Se informa deuda de prima.</p>
          <br>
        </b-col>

          
        <b-col lg="12">
          <div ref="refTable">
            <data-tables
              ref="refTable3"
              :data="dataPoliza"
              name="table"
              class="table-responsive"
              :current-page.sync="pagina"
              :table-props="tableProps2"
              :page-size="10"
              :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
              layout="table">
              <el-table-column
                v-for="title in titlesPoliza"
                :min-width="title.minwidth"
                :prop="title.prop"
                :label="title.label"
                :key="title.label"
                :align="title.align"
                :formatter="formatter"
                name="table"
                class="table-responsive">
              </el-table-column>
            </data-tables>
          </div>
        </b-col>
        <br>
        <b-col lg="12">
          <div ref="refTable">
            <data-tables
              ref="refTable3"
              :data="dataFactura"
              name="table"
              class="table-responsive"
              :current-page.sync="pagina"
              :table-props="tableProps2"
              :page-size="10"
              :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
              layout="table">
              <el-table-column
                v-for="title in titlesFactura"
                :min-width="title.minwidth"
                :prop="title.prop"
                :label="title.label"
                :key="title.label"
                :align="title.align"
                :formatter="formatter"
                name="table"
                class="table-responsive">
              </el-table-column>
            </data-tables>
          </div>
        </b-col>
        <b-col lg="12">
          <br>
          <p>Para conocer el detalle de su deuda, puede dirigirse al siguiente enlace: <a href="https://login.extranet.sc.continental.cl">Extranet de Asegurados</a><br></p>
          <br>
          <p>Saluda atentamente,</p>
          <p>Compañía de Seguros de Crédito Continental S.A.</p>
        </b-col>
      </b-row>
    </b-modal>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiTransferencias from "@/components/services/apiTransferencias";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import download from "downloadjs";
import Multiselect from "vue-multiselect";

import XLSX from "xlsx";

export default {
  name: "Transferencias",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch,
  },
  data: function () {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },

      data: [],
      dataFiniquitos: [],
      dataPoliza: [],
      dataFactura: [],

      nombreexcel: "Transferencias",
      
      titlesPoliza: [
        {
          prop: "POLIZA",
          label: "Póliza",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "PRODUCTO",
          label: "Producto",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "RAZONSOCIALBENEF",
          label: "Razón social Beneficiario",
          align: "left",
          minwidth: "250",
        },
        {
          prop: "RUTBENEF",
          label: "RUT beneficiario",
          align: "left",
          minwidth: "100",
        },
        {
          prop: "MONPAGO",
          label: "Moneda de pago",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "MTOFINIQUITO",
          label: "Monto finiquito",
          align: "right",
          minwidth: "100",
        },
        {
          prop: "FEPAGO",
          label: "Fecha de pago",
          align: "center",
          minwidth: "100",
        }
      ],
      
      titlesFactura: [
        {
          prop: "RUT",
          label: "Rut",
          align: "left",
          minwidth: "100",
        },
        {
          prop: "PAGADOR",
          label: "Pagador",
          align: "left",
          minwidth: "250",
        },
        {
          prop: "NROFACTURA",
          label: "N° Factura",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "TIPODOCUMENTO",
          label: "Tipo Documento",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "FECHAEMISION",
          label: "Fecha Emisión",
          align: "center",
          minwidth: "100",
        
        },
        {
          prop: "MONEDA",
          label: "Moneda",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "MONTO",
          label: "Monto",
          align: "right",
          minwidth: "100",
        },
        {
          prop: "SALDO",
          label: "Saldo",
          align: "right",
          minwidth: "100",
        }
      ],

      titles: [
        {
          prop: "CORRE",
          label: "Correlativo",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "POLIZA",
          label: "Póliza",
          align: "left",
          minwidth: "100",
        },
        {
          prop: "ASEGURADO",
          label: "Asegurado",
          align: "left",
          minwidth: "250",
        },
        {
          prop: "BENEFICIARIO",
          label: "Beneficiario",
          align: "left",
          minwidth: "250",
        },
        {
          prop: "MONEDA",
          label: "Moneda",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "MONTOFINIQUITO",
          label: "Monto del finiquito",
          align: "right",
          minwidth: "150",
        },
        {
          prop: "EJECUTIVO",
          label: "Ejecutivo",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "TRANSOLI",
          label: "Transferencia",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "PRCMANUAL",
          label: "Proceso Manual",
          align: "center",
          minwidth: "130",
        },
        {
          prop: "RETDEUDA",
          label: "Retenida por deuda de prima",
          align: "center",
          minwidth: "150",
        },
        {
          prop: "FESOLICICH",
          label: "Fecha Ult. Modif.",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "USUSOLICI",
          label: "Usuario",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "FECPAGOCH",
          label: "Fecha de Pago",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "FESOLTESOCH",
          label: "Fecha Sol. Tesoreria",
          align: "center",
          minwidth: "120",
        }
      ],
      
      titlesFiniquitos: [
        {
          prop: "CSHTITULO",
          label: "Nombre Finiquito",
          align: "left",
          minwidth: "250",
        },        
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'FESOLICI'){
                let elDate = new Date(row["FESOLICI"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
      ],

      datosFormulario: {
        retdeuda: "",
        transoli: "",
        prcmanual: "",
        codejecutivo: "",
        fecpago: "",
        title:"",
        regpoliza:"",
        regbeneficiario:"",
        regretdeuda:"",
        regtransoli:"",
        regprcmanual:"",
        regfecpago:"",
        ckfiniqsinsol: "n"
      },

      value: null,
      seleccionados:[],
      noseleccionables:[],
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      valEjecutivos: [],
      valRetenidas: [],
      valTransferencias: [],
      valProceso: [],
      
      multipleSelection: [],
      modalTransferencia: false,
      modalManual: false,
      modalQuitar: false,
      modalFiniquitos: false,
      modalObservacion: false,
      modalDataObservacion: "",
      modalModificar: false,
      modalEmail: false,
      tracheck: "n",
      
      multipleSelectionfin: [],
      
      
      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "CORRE"
      },
    };
  },

  components: {
    Datepicker,
    Multiselect,
  },

  methods: {

    asgckfiniqsinsol(checked){

      if (checked == 's'){
      this.datosFormulario.transoli = 'N';
          this.datosFormulario.prcmanual= 'N';
      } else {
        this.datosFormulario.transoli = 0;
          this.datosFormulario.prcmanual= 0;
      }

      this.$Progress.start();
      this.data = [];
      
      return apiTransferencias
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.retdeuda,
          this.datosFormulario.transoli,
          this.datosFormulario.prcmanual,
          this.datosFormulario.codejecutivo,
          this.datosFormulario.fecpago,
          checked
          
        )
        .then((response) => {
          
          this.data = response.data.res1;
          
          this.pagina = this.paginaAnterior;
          
          this.$Progress.finish();

          if (this.data != null) {
            this.exportar = true;
          } else {
            this.exportar = false;
          }
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
        
    },

    
    formatter(row, column, cellValue) {

      if ((column.property == "FESOLICI") || (column.property == "FECPAGO") || (column.property == "FESOLTESO")
           && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
        // return this.convierteFechaMoment(row[column.property],'').toString();
        // return this.$moment(row[column.property]).format('DD/MM/YYYY');

      } else if ((column.ppropertyrop == "MONTOFINIQUITO") && row[column.property]) {
        
        if (row[column.property] == 0 || row[column.property] == "0") {
          
          return row[column.property];

        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } 
      // else if ((column.property == "POLIZA") && row[column.property]) {
        
      //   return (<b-button type="text" @click="$bvModal.show('modalEmail')"> {{ cellValue }} </b-button>)
        
      // }
      else {
        return row[column.property];
        
      }


    
    },


    recuperar_mailDeudaPrima(p_poliza, p_beneficiario, p_retdeuda, p_transoli, p_prcmanual, p_fecpago){
      console.log(p_poliza);
      apiTransferencias
          .recuperar_mailDeudaPrima(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_poliza,
            p_beneficiario,
            p_retdeuda,
            p_transoli,
            p_prcmanual,
            p_fecpago
          )
          .then(response => {
            this.dataPoliza = response.data.res;
            this.dataFactura = response.data.res1;
            this.datosFormulario.title = this.dataPoliza[0]["TITLE"];

            this.datosFormulario.regpoliza = p_poliza;
            this.datosFormulario.regbeneficiario = p_beneficiario;
            this.datosFormulario.regretdeuda = p_retdeuda;
            this.datosFormulario.regtransoli = p_transoli;
            this.datosFormulario.regprcmanual = p_prcmanual;
            this.datosFormulario.regfecpago = p_fecpago;

            /*var lista_data = response.data.res;
            for (var i = 0; i < lista_data.length; i++) {
              this.datosFormulario.title = lista_data[i]["TITLE"];
            }*/
            
            this.$Progress.finish();
            this.modalEmail = true;
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    mail_DeudaPrima(){
      apiTransferencias
          .mail_DeudaPrima(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormulario.regpoliza,
            this.datosFormulario.regbeneficiario,
            this.datosFormulario.regretdeuda,
            this.datosFormulario.regtransoli,
            this.datosFormulario.regprcmanual,
            this.datosFormulario.regfecpago
            )
            .then(response => {
              console.log(response.data.festado.resultado.estado);
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Enviar Mail",
                "Mail enviado exitosamente",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
            
            this.modalObservacion = false;
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    guardarObservacion(){
      apiTransferencias
          .guardar_observacion(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.modalDataObservacion.POLIZA,
            this.modalDataObservacion.SNFBENEFICIARIO,
            this.modalDataObservacion.FECPAGO,
            this.modalDataObservacion.OBSERVACION
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Observación",
                "Observación guardada con éxito.",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
            
            this.modalObservacion = false;
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    guardarLinkContishare(){

      apiTransferencias
          .guardar_link_contishare(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datalink.POLIZA,
            this.datalink.SNFBENEFICIARIO,
            this.datalink.FECPAGO,
            this.linkdoccontish,
            this.nomdoccontish
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Link Contishare",
                "Link de Contishare guardada con éxito.",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
            
            this.modalObservacion = false;
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    customButtonsForRowObs(row) {
          var botones = new Array();
          
          
            var obj = new Object();
            obj.tooltip = "Modificar";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-pencil-square-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                this.modalDataObservacion = row;
                this.modalObservacion = true;
                
            }
            botones.push(obj);
          
          
          return botones;

    },

    verFiniquito(link) {
      window.open(link, '_blank');
    },

    customButtonsForRow(row) {
          var botones = new Array();
          
          if (row.INFORME)
          {
            var obj = new Object();
            obj.tooltip = "PDF";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-file-pdf-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.INFORME, '_blank');
            }
            botones.push(obj);
          }

          if (row.CORREO)
          {
            var obj = new Object();
            obj.tooltip = "Correo";
            obj.id = 2;
            obj.name="";
            obj.icon = "fa fa-envelope-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.CORREO, '_self');
            }
            botones.push(obj);
          }
          
          return botones;

    },

    getDate(date) {
      let elDate = new Date(date)
      return elDate.getDate() + '/' + (elDate.getMonth() + 1) + '/' + elDate.getFullYear();   
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row);
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    validaSeleccion(selection, row) {
    
        if (row["FESOLTESO"] == undefined && row["TRANSOLI"] == 'S')  {
          //  this.$refs.refTable1.$children[0].toggleRowSelection(row, false);
           this.crearNotificacion("Validación","Esta transferencia no ha sido solicitada a Tesorería","error");  
           return false;
        };
      
    },

    validaSeleccionAll(rows) {
    console.log("prueba", rows);

    let v_seleccionables = rows.filter(function (el) { if (el.FESOLTESO != undefined)  return el; })
      
    let v_noseleccionables = rows.filter(function (el) { if (el.FESOLTESO == undefined && el.TRANSOLI == "S")  return el; })



      if (this.seleccionados.length<=0 ){ 
        
        this.seleccionados = v_seleccionables;
        v_seleccionables.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row, true);
        })

      } else {
        this.$refs.refTable1.$children[0].clearSelection();
        this.seleccionados=[]; 
      }

      if (this.noseleccionables.length<=0 ){ 
        
        this.noseleccionables = v_noseleccionables;
        v_noseleccionables.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row, false);

        })

      } else {
        this.$refs.refTable1.$children[0].clearSelection();
        this.noseleccionables=[]; 
      }
   
    },

    handleSelectionChange2(selection, row) {

      this.nomdoccontish = row.CSHTITULO;
      this.linkdoccontish = row.LINK;

      // this.link = row
      // debugger;
      if (selection.length > 1 ) {
            this.crearNotificacion("Error de sistema", "Solo se puede seleccionar un solo registro", "error");
            this.$refs.refTable3.$children[0].toggleRowSelection(row, false);
            return;
           }
    },

    selectAll(rows){
      this.$refs.refTable3.$children[0].clearSelection();
      return;
    },

    
    

    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },

    cambiarFechas() {
      if (this.datosFormulario.selected == "A") {
        this.mostrarFechas = false;
      } else {
        this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
      n = String(n).replace(/\D/g, "");
      return n === "" ? n : Number(n).toLocaleString();
    },

    totales(param) {
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));

        if (!values.every((value) => isNaN(value))) {
          sums[index] = this.$numeral(
            values.reduce((prev, curr) => {
              const value = Number(curr);

              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          ).format();
          /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    exportarExcel() {
      this.$nextTick(function () {
        var tabla = document.getElementById("tableExcel");
        var data = XLSX.utils.table_to_sheet(tabla);
        const workbook = XLSX.utils.book_new();
        const filename = "Export";
        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      });
    },

    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;
      return apiTransferencias
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          
          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == "s") {
            this.tieneAcceso = true;
          } else {
            this.tieneAcceso = false;
          }

          this.valEjecutivos = this.llenaArrayLista(response.data.ejecutivos, 'codejecutivo', 'des_ejecutivo', false);
          this.valRetenidas = this.llenaArrayLista(response.data.retdeuda, 'retdeuda', 'desc_retdeuda', false);
          this.valTransferencias = this.llenaArrayLista(response.data.transoli, 'transoli', 'desc_transoli', false);
          this.valProceso = this.llenaArrayLista(response.data.prcmanual, 'prcmanual', 'desc_prcmanual', false);
          

          var lista_data = response.data.res;
          for (var i = 0; i < lista_data.length; i++) {
            this.datosFormulario.retdeuda = lista_data[i]["retdeuda"];
            this.datosFormulario.transoli = lista_data[i]["transoli"];
            this.datosFormulario.prcmanual = lista_data[i]["prcmanual"];
            this.datosFormulario.codejecutivo = lista_data[i]["codejecutivo"];
            this.datosFormulario.fecpago = lista_data[i]["fecpago"];
            this.datosFormulario.hoy = lista_data[i]["hoy"];
          }

          this.datosFormularioEstado = response.data.festado;
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();
      this.data = [];
      this.datosFormulario.ckfiniqsinsol = 'n';
      
      return apiTransferencias
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.retdeuda,
          this.datosFormulario.transoli,
          this.datosFormulario.prcmanual,
          this.datosFormulario.codejecutivo,
          this.datosFormulario.fecpago,
          'n'
        )
        .then((response) => {
          
          this.data = response.data.res1;
          
          this.pagina = this.paginaAnterior;
          
          this.$Progress.finish();

          if (this.data != null) {
            this.exportar = true;
          } else {
            this.exportar = false;
          }
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    

    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;
      // columnas += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>Observación</td>\n";

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        "class=xl689618 width=698 style='width:526pt;" +
        xl689618 +
        "'>Transferencias</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          "Observación" +
          "</td>\n";
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      for (var key in this.data) {
        if(this.data[key]["CORRE"] == undefined){
          this.data[key]["CORRE"] = "";
        }
        if(this.data[key]["POLIZA"] == undefined){
          this.data[key]["POLIZA"] = "";
        }
        if(this.data[key]["ASEGURADO"] == undefined){
          this.data[key]["ASEGURADO"] = "";
        }
        if(this.data[key]["BENEFICIARIO"] == undefined){
          this.data[key]["BENEFICIARIO"] = "";
        }
        if(this.data[key]["MONEDA"] == undefined){
          this.data[key]["MONEDA"] = "";
        }
        if(this.data[key]["MONTOFINIQUITO"] == undefined){
          this.data[key]["MONTOFINIQUITO"] = "";
        }
        if(this.data[key]["EJECUTIVO"] == undefined){
          this.data[key]["EJECUTIVO"] = "";
        }
        if(this.data[key]["TRANSOLI"] == undefined){
          this.data[key]["TRANSOLI"] = "";
        }
        if(this.data[key]["PRCMANUAL"] == undefined){this.data
          this.data[key]["PRCMANUAL"] = "";
        }
        if(this.data[key]["RETDEUDA"] == undefined){
          this.data[key]["RETDEUDA"] = "";
        }
        if(this.data[key]["FESOLICI"] == undefined){
          this.data[key]["FESOLICI"] = "";
        }
        if(this.data[key]["USUSOLICI"] == undefined){
          this.data[key]["USUSOLICI"] = "";
        }
        if(this.data[key]["OBSERVACION"] == undefined){
          this.data[key]["OBSERVACION"] = "";
        }
        if(this.data[key]["FECPAGOCH"] == undefined){
          this.data[key]["FECPAGOCH"] = "";
        }
        if(this.data[key]["FESOLTESOCH"] == undefined){
          this.data[key]["FESOLTESOCH"] = "";
        }


        
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["CORRE"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["POLIZA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ASEGURADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["BENEFICIARIO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["MONEDA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["MONTOFINIQUITO"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["EJECUTIVO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["TRANSOLI"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["PRCMANUAL"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["RETDEUDA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["FESOLICI"])+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["USUSOLICI"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.data[key]["FECPAGOCH"]+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.data[key]["FESOLTESOCH"]+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["OBSERVACION"] + "</td>\n";
        cuerpo += "</tr>\n";
      }


      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      console.log("fecha: ", fechaEntrada);
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },



    finiquitos(poliza, row){
      this.$Progress.start();
      return apiTransferencias
        .finiquitos(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          poliza
        )
        .then((response) => {
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          this.dataFiniquitos = response.data.res1;
          this.datalink = row;
          this.modalFiniquitos = true;
          
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    imprime_finiquitos(p_poliza, p_beneficiario, p_fepago){
      this.$Progress.start();
      return apiTransferencias
        .mail_finiquito(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          p_poliza,
          p_beneficiario,
          p_fepago
        )
        .then((response) => {
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          // this.dataFiniquitos = response.data.res1;
          // this.modalFiniquitos = true;
          this.crearNotificacion(
                  response.data.festado.resultado.titulo,
                  response.data.festado.resultado.mensaje,
                  response.data.festado.resultado.estado
                );
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },


    trasferencia(){
      this.$Progress.start();

      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.CORRE);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["CORRE"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
      /* -- */

      var siniestrosMarcados = "";
      var index = 0;
      
      for (index = 0; index < marcados.length; ++index) {
        //siniestrosMarcados += marcados[index]["SINIESTRO"] + ',';
        siniestrosMarcados += marcados[index]["POLIZA"] + ',' + marcados[index]["SNFBENEFICIARIO"] + ',' + marcados[index]["MONEDA"] + ',' + 
                              marcados[index]["FECPAGO"] + ',' + 'S' + ',' + 'N' + ',' + 'a' + ';';
      }
      
      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiTransferencias
          .transferir(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosMarcados
          )
          .then(response => {
            this.$Progress.finish();
            
            this.crearNotificacion(
                  response.data.festado.resultado.titulo,
                  response.data.festado.resultado.mensaje,
                  response.data.festado.resultado.estado
                );

            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
      this.$Progress.finish();
    },

    manual(){
      this.$Progress.start();

      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.CORRE);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["CORRE"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
      /* -- */

      var siniestrosMarcados = "";
      var index = 0;
      
      for (index = 0; index < marcados.length; ++index) {
        //siniestrosMarcados += marcados[index]["SINIESTRO"] + ',';
        siniestrosMarcados += marcados[index]["POLIZA"] + ',' + marcados[index]["SNFBENEFICIARIO"] + ',' + marcados[index]["MONEDA"] + ',' + 
                              marcados[index]["FECPAGO"] + ',' + 'N' + ',' + 'S' + ',' + 'a' + ';';
      }
      
      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiTransferencias
          .transferir(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosMarcados
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                  response.data.festado.resultado.titulo,
                  response.data.festado.resultado.mensaje,
                  response.data.festado.resultado.estado
                );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
      this.$Progress.finish();
    },

    quitar(){
      this.$Progress.start();

      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.CORRE);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["CORRE"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
      /* -- */

      var siniestrosMarcados = "";
      var index = 0;
      
      for (index = 0; index < marcados.length; ++index) {
        //siniestrosMarcados += marcados[index]["SINIESTRO"] + ',';
        siniestrosMarcados += marcados[index]["POLIZA"] + ',' + marcados[index]["SNFBENEFICIARIO"] + ',' + marcados[index]["MONEDA"] + ',' + 
                              marcados[index]["FECPAGO"] + ',' + 'N' + ',' + 'N' + ',' + 'a' + ';';
      }
      
      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiTransferencias
          .transferir(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosMarcados
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                  response.data.festado.resultado.titulo,
                  response.data.festado.resultado.mensaje,
                  response.data.festado.resultado.estado
                );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
      this.$Progress.finish();
    },

    valmarcados(p_opcion){
  
      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.CORRE);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["CORRE"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
      /* -- */

       this.multipleSelection = marcados;
      if (this.multipleSelection.length > 0){
         if (p_opcion == 'A') {this.modalTransferencia = true}
         else if (p_opcion == 'B') {this.modalManual = true}
         else if (p_opcion == 'C') {this.modalQuitar = true}
         else if (p_opcion == 'D') {this.modalModificar = true}
      }else{
        this.crearNotificacion(
                "Marcar",
                "No tiene registros seleccionados.",
                "error"
              );
      }
      
    },
    
    fechatransferencia(){
       this.$Progress.start();

      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.CORRE);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["CORRE"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
       
      var siniestrosMarcados = "";
      var index = 0;
      for (index = 0; index < marcados.length; ++index) {
        //siniestrosMarcados += marcados[index]["SINIESTRO"] + ',';
        siniestrosMarcados += marcados[index]["POLIZA"] + ',' + marcados[index]["SNFBENEFICIARIO"] + ',' + marcados[index]["MONEDA"] + ',' + 
                              marcados[index]["FECPAGO"] + ',' + marcados[index]["TRANSOLI"] + ',' + marcados[index]["PRCMANUAL"] + ',' + 'a' + ';';
      }
      // console.log(siniestrosMarcados);
      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiTransferencias
          .fechatransferencia(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormulario.hoy,
            siniestrosMarcados
          )
          .then(response => {
            this.$Progress.finish();
            
            this.crearNotificacion(
                   response.data.festado.resultado.titulo,
                   response.data.festado.resultado.mensaje,
                   response.data.festado.resultado.estado
                );

            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
      this.$Progress.finish();
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor];
            obj.text = data[i][texto];
          }
          arr.push(obj);
          
      }
      return arr;
    },
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },

  watch: {
    pagina: function (nuevo, anterior) {
      this.paginaAnterior = anterior;
    },

    data: function() {
      this.$nextTick(function() {
        this.$refs.refTable1.$children[0].clearSelection();
        var lista = this.data;
        var index = 0;
        for (index = 0; index < lista.length; ++index) {
            // this.toggleSelection([lista[index]]);
        }
      })
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

.bt_fecransferencia{
  background-color: #8E44AD !important;
}

.multiselect__tag {
  background: #20a8d8 !important;
}
.multiselect__option--highlight:after {
  background: #20a8d8 !important;
}

.multiselect__option--highlight {
  background: #20a8d8 !important;
}
.multiselect__tags {
  border-radius: 0px !important;
  min-height: 70px !important;
}
.label-blanco{
  color: #fff;
}

</style>
